import api from "../../../services/api";
//import axios from "axios";
export default {
  name: "AdesaoCad",
  props: ["emp"],

  data() {
    return {
      adesao: [],
      titulo: "Nova Adesão",

      logo: "salus.png",

      ativProf: [],

      form: {
        nome: "",
        cpf: "",
        email: "",
        confEmail: "",
        celular: "",
        celAdic: "",
        fixo: "",
        cep: "",
        cidade: "",
        uf: "",
        bairro: "",
        endereco: "",
        atividadeProf: null,
        regProf: "",
        regNum: "",
        regDataVencimento: null
      },

     
      show: true,
      botaoVisivel: true,

      dadosEmpresa: null,
      bgColor: "#a1a1a1",

      naoRecebiCodigo: false,
      codVerificacao: ["", "", "", "", "", ""],

      idSolicitacao: '',

      msgValidacao: '',

      enviandoEmail: false,
      confirmandoEmail: false,

      keyValidacao: null,

      tituloModalVerificacao: 'Validação de e-mail'

    };
  },

  created() {

    
  // alert(this.$route.query.emp)
    const empresa = this.$route.query.emp
   

    api
      .get(`adesao/empresa/${empresa}/null`)
      .then((res) => {
        // console.log(res.data);
        this.dadosEmpresa = res.data;
        this.bgColor = res.data.cor;
        this.logo = res.data.logoPath;

        if (!this.dadosEmpresa) this.$router.push("/adesao/erro");

      })
      .catch(() => {
        if (!this.dadosEmpresa) this.$router.push("/adesao/erro");
        //this.msg("ERRO AO BUSCAR", err.response.data, "danger")
      });
   
  },

  methods: {

    msg(titulo, texto, cor) {
      this.toastCount++;
      this.$bvToast.toast(texto, {
        title: titulo,
        variant: cor,
        solid: true,
        autoHideDelay: 10000,
        appendToast: true
      });
    },
 



    consultarCpf() {
        // Só chama a API se o CPF estiver completo
        const empresa = this.$route.query.emp; // pega o ?emp=...
        
        if (!empresa) {
            this.msg("ATENÇÃO", "Empresa não informada!", "warning");
            return;
        }



        if (this.form.cpf.length === 14) {

        api.get(`adesao/ConsultaTracking/${empresa}/${this.form.cpf}`)
            .then((response) => {
                
                if( response.data.status === 'cpf_invalido'){
                   this.msg("ATENÇÃO", `CPF ${response.data.cpf} inválido!`, "warning");
                }

                if( response.data.status === 'cpf_existe_gestao'){
                   this.msg("ATENÇÃO", `CPF ${response.data.cpf} já cadastrado no nosso ERP, entrar em contato com o departamento de Adesão.`, 'info')
                }

                if (response.data.status === 'cpf_nao_existe_contratei') {
                    this.msg("ATENÇÃO", `Cpf ${response.data.cpf} não está cadastrado, redirecionando para tela de adesão!`, 'info');

                    setTimeout(() => {
                        window.open(response.data.link, '_blank');
                    }, 5000);
                }

                if (response.data.status === 'email_enviado') {
                    this.msg("ATENÇÃO", `Um e-mail foi enviado para ${response.data.email} com mais informações. Verifique sua caixa de entrada!`, 'info');
                }
            
            })
            .catch((error) => {
                  const mensagem = error.response?.data || 'Erro inesperado!';

                   this.msg("ATENÇÃO", mensagem, 'error');
            })
            .finally(() => {
              this.form.cpf = "";
            });
        } else {
            this.msg("ATENÇÃO", 'CPF incompleto!', 'warning');
        }
        }
    },

  computed: {
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--height": this.height + "px",
      };
    },
  },
};